const dateFormat = {
  timeObjects: {
    year: "year",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second"
  },
  months: {
    jan: {
      short: "Jan",
      long: "January"
    },
    feb: {
      short: "Feb",
      long: "February"
    },
    mar: {
      short: "Mar",
      long: "March"
    },
    apr: {
      short: "Apr",
      long: "April"
    },
    may: {
      short: "May",
      long: "May"
    },
    jun: {
      short: "Jun",
      long: "June"
    },
    jul: {
      short: "Jul",
      long: "July"
    },
    aug: {
      short: "Aug",
      long: "August"
    },
    sep: {
      short: "Sep",
      long: "September"
    },
    oct: {
      short: "Oct",
      long: "October"
    },
    nov: {
      short: "Nov",
      long: "November"
    },
    dec: {
      short: "Dec",
      long: "Decmeber"
    }
  },
  weekdays: {
    mon: {
      short: "Mon",
      long: "Monday"
    },
    tue: {
      short: "Tue",
      long: "Tuesday"
    },
    wed: {
      short: "Wed",
      long: "Wednesday"
    },
    thr: {
      short: "Thr",
      long: "Thursday"
    },
    fri: {
      short: "Fri",
      long: "Friday"
    },
    sat: {
      short: "Sat",
      long: "Saturday"
    },
    sun: {
      short: "Sun",
      long: "Sunday"
    }
  }
};
export default dateFormat;
